<div class="container-fluid">
  <div [ngClass]="login.contraste ? 'card-panel mt-5 fundo-contraste' : 'card-panel mt-5 fundo-normal'">
    <div class="row">
      <div class="col-md-6 col-sm-4 pb-0 mb-0">
        <table>
          <td style="vertical-align: middle;"><img src="assets/img/global/folha.png" alt="" title="" width="42" height="42">
          </td>
          <td>
            <p
              [ngClass]="this.login.contraste ? 'titulo-txt-contraste fonte-acessibilidade m-0' : 'titulo-txt-normal fonte-acessibilidade m-0'">
              REMUNERAÇÃO SERVIDORES PÚBLICOS</p>
            <p
              [ngClass]="this.login.contraste ? 'subtitulo-txt-contraste fonte-acessibilidade m-0' : 'subtitulo-txt-normal fonte-acessibilidade m-0'">
              EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}</p>
          </td>
        </table>
      </div>
      <div class="col-md-6 col-sm-8 pb-0 mb-0">
        <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="22" width="22">
        </button>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
      </div>
    </div>
    <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-4'" />
    <div class="row">
      <div class="form-group col-sm-4 col-md-3 col-lg-2 col-xl-2">
        <select [(ngModel)]="selectExercicio" (change)="preencherGrid()" name="selectExercicio"
          style="border: none !important" style="font-weight: bold;" class="custom-select">
          <option [selected]="item.ano === selectExercicio" [value]="item.ano" *ngFor="let item of listaExercicios">
            {{item.ano}}
          </option>
        </select>
      </div>
      <div class="form-group col-sm-4 col-md-3 col-lg-2 col-xl-2">
        <select [(ngModel)]="mes" (change)="preencherGrid()" name="selectMes" style="border: none !important"
          style="font-weight: bold;" class="custom-select">
          <option [selected]="item.id === mes" [value]="item.id" *ngFor="let item of listaMeses">
            {{item.nome}}
          </option>
        </select>
      </div>
      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2">
        <select [(ngModel)]="referencia" (change)="preencherGrid()" name="selectReferencia"
          style="border: none !important" style="font-weight: bold;" class="custom-select">
          <option [selected]="item === referencia" [value]="item" *ngFor="let item of listaReferencia">
            {{item}}
          </option>
        </select>
      </div>
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-6">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length > 0">
      <div class="col-md">
        <div class="table-responsive">
          <table
            [ngClass]="login.contraste ? 'table table-dark fonte-acessibilidade' : 'table table-eddy fonte-acessibilidade'">
            <thead>
              <tr style="height: 42px;">
                <th scope="col">
                  <a href="javascript:;" (click)="ordenar(1)"
                    [ngClass]="login.contraste ? 'text-white fonte-acessibilidade' : 'text-black-50 fonte-acessibilidade'">
                    <span *ngIf="col === 1"><img src="assets/img/global/{{imagem}}" alt="localizar" height="16"
                        width="16">&nbsp;</span>NOME/ADMISSÃO
                  </a>
                </th>
                <th scope="col">
                  <a href="javascript:;" (click)="ordenar(2)"
                    [ngClass]="login.contraste ? 'text-white fonte-acessibilidade' : 'text-black-50 fonte-acessibilidade'">
                    <span *ngIf="col === 2"><img src="assets/img/global/{{imagem}}" alt="localizar" height="16"
                        width="16">&nbsp;</span>CARGO/DEPARTAMENTO
                  </a>
                </th>
                <th scope="col">
                  <a href="javascript:;" (click)="ordenar(3)"
                    [ngClass]="login.contraste ? 'text-white fonte-acessibilidade' : 'text-black-50 fonte-acessibilidade'">
                    <span *ngIf="col === 3"><img src="assets/img/global/{{imagem}}" alt="localizar" height="16"
                        width="16">&nbsp;</span>CÁLCULO
                  </a>
                </th>
                <th scope="col">
                  <a href="javascript:;" (click)="ordenar(4)"
                    [ngClass]="login.contraste ? 'text-white fonte-acessibilidade' : 'text-black-50 fonte-acessibilidade'">
                    <span *ngIf="col === 4"><img src="assets/img/global/{{imagem}}" alt="localizar" height="16"
                        width="16">&nbsp;</span>REFERÊNCIA
                  </a>
                </th>
                <th scope="col" class="text-right">
                  <a href="javascript:;" (click)="ordenar(5)"
                    [ngClass]="login.contraste ? 'text-white fonte-acessibilidade' : 'text-black-50 fonte-acessibilidade'">
                    <span *ngIf="col === 5"><img src="assets/img/global/{{imagem}}" alt="localizar" height="16"
                        width="16">&nbsp;</span>VALOR BRUTO
                  </a>
                </th>
                <th scope="col" class="text-right">
                  <a href="javascript:;" (click)="ordenar(6)"
                    [ngClass]="login.contraste ? 'text-white fonte-acessibilidade' : 'text-black-50 fonte-acessibilidade'">
                    <span *ngIf="col === 6"><img src="assets/img/global/{{imagem}}" alt="localizar" height="16"
                        width="16">&nbsp;</span>DESCONTOS
                  </a>
                </th>
                <th scope="col" class="text-right">
                  <a href="javascript:;" (click)="ordenar(7)"
                    [ngClass]="login.contraste ? 'text-white fonte-acessibilidade' : 'text-black-50 fonte-acessibilidade'">
                    <span *ngIf="col === 7"><img src="assets/img/global/{{imagem}}" alt="localizar" height="16"
                        width="16">&nbsp;</span>VALOR LÍQUIDO
                  </a>
                </th>
                <th scope="col" style="width: 100px;"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista">
                <td>
                  <span class="font-weight-bold">{{item.funcionario.pessoa.nome}}</span><br />
                  Admissão: {{item.funcionario.data_admissao | date:'dd/MM/yyyy':'GMT'}}
                </td>
                <td>
                  {{item.funcionario.cargo.nome}}<br />
                  {{item.funcionario.departamento.nome}}
                </td>
                <td class="text-center">{{item.calculo}}</td>
                <td class="text-center">{{item.referencia.mes}}/{{item.referencia.ano}}</td>
                <td class="text-right">{{item.valor_bruto | number:'1.2-2'}}</td>
                <td class="text-right">{{item.valor_desconto | number:'1.2-2'}}</td>
                <td class="text-right">{{item.valor_liquido | number:'1.2-2'}}</td>
                <td style="width: 100px;" class="text-right">
                  <button
                    [routerLink]="['/remuneracao-servidores/visualiza', item.id, paginaCorrente, this.mes, this.ano, this.referencia]"
                    routerLinkActive="router-link-active" class="btn btn-sm btn-outline-secondary mr-2">
                    <img src="assets/img/global/zoom.png" alt="visualizar" height="16" width="16">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
    <div class="row" *ngIf="lista && lista.length === 0">
      <div class="col-12 mt-5 ml-3">
        <img src="assets/img/global/warning.png" alt="atencao" class="mb-1">
        <br />
        <span
          [ngClass]="this.login.contraste ? 'text-white font-weight-bold ml-1' : 'text-black-50 font-weight-bold ml-1'">
          NÃO HÁ LANÇAMENTOS EFETUADOS! </span>
      </div>
    </div>
  </div>
</div>
